import {Resolver} from 'airship/utils/resolvers/types'
import {
  objectResolver,
  resolveBoolean,
  resolveString,
} from 'airship/utils/resolvers'

export interface Recaptcha {
  recaptcha_site_key: string
  require_captcha: boolean
}
export interface Context {
  context_processors: {
    recaptcha: Recaptcha
  }
}

const resolveRecaptcha: Resolver<Recaptcha> = objectResolver({
  recaptcha_site_key: resolveString,
  require_captcha: resolveBoolean,
})

export const resolveContext: Resolver<Context> = objectResolver({
  context_processors: objectResolver({
    recaptcha: resolveRecaptcha,
  }),
})
